export const config = {
    appname: 'tbank',
    agencyId: '7459',
    client_id: '1007101429346759', // App ID
    facebook_app_id: '1007101429346759', // Facebook App ID (Should be the same)
    debug: false, //enable console.log

    // ------------- Production Settings ----------------
    api: 'apitni2',
    bzbsUrl: 'https://apitni2.buzzebees.com',
    bzbsModuleUrl: 'https://tbankmodule.buzzebees.com',
    apiShoppingCartUrl: 'https://shoppingcartmodule23.buzzebees.com',
    webShoppingCartUrl: 'https://shoppingcartservice23.buzzebees.com',
    // bzbsBlobUrl: 'https://cdn.buzzebees.com/th',
    bzbsBlobUrl: 'https://cdn.buzzebees.com/th',
    miscUrl: 'https://misc.buzzebees.com',
    // ------------------ End Settings ---------------------
    fbLogOnUrl: 'https://www.facebook.com/dialog/oauth?',
    fbPermissions: [
        'email',
    ],

    firebase: {
        apiKey: "AIzaSyC42mY_M9Z4LwHeiv_Hr75DfVCnKvBoRXY",
        authDomain: "tni-line-prd.firebaseapp.com",
        projectId: "tni-line-prd",
        storageBucket: "tni-line-prd.appspot.com",
        messagingSenderId: "352010171293",
        appId: "1:352010171293:web:0b9be2035c51bb5be47574",
        measurementId: "G-X8GBT8DJT5"
    },
    lineId: "@thanachartinsure",
};
